import { Row, Col, Button, notification } from "antd";
import React, { startTransition, useEffect, useState } from "react";
import SectionWrapper from "../../../components/pageComponents/SectionWrapper";
import { OfferingCourseCard } from "../../Home/CourseOfferings";
import axios from "axios";
import { __hideLoader, __showLoader } from "../../../Redux Store/Slices/loader";
import { useDispatch, useSelector } from "react-redux";
import { courseEnrollmentsOfUserUrl, courseUrl } from "../../../urls";
import useErrorHandler from "../../../hooks/useErrorHandler";
import { useNavigate } from "react-router-dom";
import CourseCard from "../../../components/cards/CourseCard";

const DashboardHome = () => {
  const [courses, setCourses] = useState([]);
  const dispatch = useDispatch();
  const handleError = useErrorHandler();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  console.log({ user1: user });

  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    dispatch(__showLoader("Getting Courses"));
    axios
      .get(courseEnrollmentsOfUserUrl + user.username)
      .then((res) => {
        setCourses(res.data);
      })
      .catch((err) => {
        handleError(err);
      })
      .finally(() => {
        dispatch(__hideLoader());
      });
  }, []);
  console.log({ courses });

  return (
    <div className="flex flex-col gap-12">
      {/* <SectionWrapper
                title="Assignments" rightComp={<Button type="default">View All Assignments</Button>}
            >
                <Row gutter={[16, 16]}>
                    {assignments.map((assignment, index) => (
                        <Col key={index} xs={24} sm={12} lg={8}>
                            <AssignmentCard
                                title={assignment.title}
                                description={assignment.description}
                                dueDate={assignment.dueDate}
                                status={assignment.status}
                                avatarSrc={assignment.avatarSrc}
                            />
                        </Col>
                    ))}
                </Row>
            </SectionWrapper> */}

      <SectionWrapper
        title="Your Courses"
      // rightComp={
      //   <Button type="default" onClick={() => navigate("courses")}>
      //     View All Courses
      //   </Button>
      // }
      >
        <div className="w-full gap-4">
          <Row gutter={[16, 16]}>
            {!courses.length ? (
              <p>Courses Not Purchased</p>
            ) : (
              courses.map((course, index) => (
                <Col xs={24} sm={12} md={8} key={index}>
                  {" "}
                  {console.log({ course })}
                  {/* 24 for sm (full width), 6 for md (4 columns) */}
                  <CourseCard
                    label
                    id={course.course.id}
                    tags={course.course.tags}
                    isCourseCompleted={course.isCourseCompleted}
                    enrollmentId={course.id}
                    title={course.course.title || course.course.name}
                    description={course.course.description}
                    purchaseDate={course.course.purchaseDate}
                    //   imageSrc={course.course.thumbnail}
                    isEnrollDirect
                  />
                </Col>
              ))
            )}
          </Row>
        </div>
      </SectionWrapper>
    </div>
  );
};

export default DashboardHome;
